import { useWizard } from "../useWizard/useWizard";
import type { UseWizardWithOperationsProps, WizardOperation } from "./types";
import { useWizardOperationController } from "./useWizardOperationController";

export const useWizardWithOperations = <
  TStep extends PropertyKey,
  TOperation extends WizardOperation,
>({
  steps,
  executeOperation,
  onComplete,
  onError,
}: UseWizardWithOperationsProps<TStep, TOperation>) => {
  const { operations, completeWizardWithOperations } =
    useWizardOperationController({
      executeOperation,
      onComplete,
      onError,
    });

  const wizard = useWizard({
    steps,
    onComplete: completeWizardWithOperations,
  });

  return { operations, wizard };
};
